import { Board } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useSharedFormationPersistence(): useSharedFormationPersistenceReturn {
  return useLazyContext(SharedFormationPersistenceContext);
}

export const SharedFormationPersistenceContext =
  createContext<LazyValue<useSharedFormationPersistenceReturn>>(undefined);

export type useSharedFormationPersistenceReturn = {
  createFormation: (formation: Board, createdAt: Date) => Promise<string>;
  getFormation: (id: string) => Promise<Board>;
};
